'use client';

import {
  createContext,
  useContext,
  ReactNode,
  useState,
  useMemo,
} from 'react';

type VisitedPagesContextType = {
  visitedPages: string[];
  setVisitedPages: any;
};

const VisitedPagesContext = createContext<VisitedPagesContextType | undefined>(
  undefined,
);

export const useVisitedPages = () => {
  const context = useContext(VisitedPagesContext);
  if (!context) {
    throw new Error(
      'useVisitedPages must be used within a VisitedPagesProvider',
    );
  }
  return context;
};

export const VisitedPagesProvider = ({ children }: { children: ReactNode }) => {
  const [visitedPages, setVisitedPages] = useState<string[]>([]);

  const contextValue = useMemo(
    () => ({
      visitedPages,
      setVisitedPages,
    }),
    [visitedPages],
  );

  return (
    <VisitedPagesContext.Provider value={contextValue}>
      {children}
    </VisitedPagesContext.Provider>
  );
};
